import { withLDConsumer } from 'launchdarkly-react-client-sdk';

export const withFeatureFlagConsumer = withLDConsumer();
